<template>
  <div class="card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar un nuevo seguimiento</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form ref="form" class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Estado (*)</label>

                <el-select
                  v-model="formData.state"
                  v-validate="modelValidations.state"
                  name="state"
                  placeholder="Estado"
                >
                  <el-option
                    v-for="option in statesOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>

                <small v-show="state.invalid" class="text-danger">{{ getError('state') }}</small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Cantidad</label>

                <el-input
                  v-model="formData.quantity"
                  v-validate="modelValidations.quantity"
                  name="quantity"
                  placeholder="Cantidad"
                >
                </el-input>

                <small v-show="quantity.invalid" class="text-danger">{{ getError('quantity') }}</small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Comentario</label>

                <el-input
                  v-model="formData.comment"
                  v-validate="modelValidations.comment"
                  name="comment"
                  placeholder="Ingresar comentario"
                  type="textarea"
                  rows="10"
                >
                </el-input>
                <small v-show="comment.invalid" class="text-danger">{{ getError('comment') }}</small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Fecha Próximo Seguimiento</label>

                <el-date-picker
                  v-model="formData.nextFollowUpDate"
                  :editable="false"
                  align="center"
                  format="dd/MM/yyyy"
                  name="nextFollowUpDate"
                  placeholder="Fecha Próximo Seguimiento (*)"
                  suffix-icon="fas fa-calendar-alt"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <small v-show="nextFollowUpDate.invalid" class="text-danger">
                  {{ getError('nextFollowUpDate') }}
                </small>
              </div>
            </div>

            <server-error :server-errors="serverErrors" />

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';
import { mapFields } from 'vee-validate';
import { DatePicker } from 'element-ui';
import ServerError from '../../../components/ServerError';
import moment from 'moment';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    ServerError,
  },

  props: {
    serverErrors: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      modelValidations: {
        comment: {
          required: true,
        },

        quantity: {
          required: true,
          numeric: true,
        },

        state: {
          required: true,
        },
      },

      formData: {
        comment: null,
        quantity: null,
        state: null,
        nextFollowUpDate: moment(this.nextFollowUpDate).format('YYYY-MM-DD HH:mm'),
      },

      canceledState: null,
    };
  },

  computed: {
    ...mapFields(['comment', 'quantity', 'state', 'nextFollowUpDate']),
    ...mapGetters('models/projection', ['getStateByName']),
    ...mapState('models/projection', ['states']),
    statesOptions() {
      return this.$selectOptions(this.states, { label: 'label' });
    },
  },

  watch: {
    'formData.state': {
      handler: function (newVal, oldVal) {
        if (newVal === this.canceledState.id) {
          this.formData.comment = this.canceledState.label;
          this.formData.quantity = 0;
        } else if (oldVal === this.canceledState.id) {
          this.cleanForm(this.formData.state);
        }
      },
    },
  },

  created() {
    this.formData.nextFollowUpDate = null;
    this.canceledState = this.getStateByName('danger');
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    cleanForm(state = null) {
      this.formData.nextFollowUpDate = null;
      this.formData.comment = null;
      this.formData.quantity = null;
      this.formData.state = state;
      this.$refs.form.reset();
      this.errors.clear();
      this.$validator.reset();
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--datetime,
.form-group .el-date-editor--date {
  width: 100%;
}

.el-date-range-picker .el-picker-panel__footer .el-button,
.el-date-picker .el-picker-panel__footer .el-button {
  display: inline-block;
  cursor: pointer;
  position: relative;
  margin: 1px;
  font-size: 0.75rem;
  color: #11cdef;
  background-color: #fff;
  border-width: 1px;
  border-radius: 0.25rem;
  border-color: #11cdef;
  transition: all 0.15s ease;
}
</style>
